import script from "./modalInstitutionCouverts.vue?vue&type=script&setup=true&lang=js"
export * from "./modalInstitutionCouverts.vue?vue&type=script&setup=true&lang=js"

import "./modalInstitutionCouverts.vue?vue&type=style&index=0&id=fa9922c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa9922c8"]])

export default __exports__